export default __webpack_public_path__ + "static/proximanova-bold-f9527cb231fbb96f8b847c6bb2577e73.woff2";